import { Grid } from '@mui/material';
import { useForm } from 'react-hook-form';
import { fieldIsRequiredMsg } from '../../utils/componentUtils';
import FormDialog from '../Dialogs/FormDialog';
import ReactHookFormTextField from '../ReactHookForm/ReactHookFormTextField';
import { FC } from 'react';
import { Forecaster } from '../../types/Forecaster.interface';
import ReactHookFormAutoComplete from '../ReactHookForm/ReactHookFormAutoComplete';
import { UserName } from '@callmart/types';

interface ForecasterDialogProps {
    forecaster?: Forecaster;
    showDialog: boolean;
    users: UserName[];
    onSubmit: any;
    isLoading: boolean;
    onClose: any;
}

const ForecasterDialog: FC<ForecasterDialogProps> = ({
    forecaster,
    showDialog,
    users,
    onSubmit,
    isLoading,
    onClose,
}) => {
    const form = useForm({
        defaultValues: {
            id: forecaster?.id || '',
            name: forecaster?.name || '',
            user: users.find((user) => user.id === forecaster?.userId) || null,
            userId: forecaster?.userId || null,
        },
    });
    const {
        formState: { errors },
        control,
    } = form;

    const handleClose = () => {
        onClose();
    };

    return (
        <FormDialog
            title={forecaster?.id ? 'Bearbeiten der Forecaster' : 'Neue Forecaster'}
            showDialog={showDialog}
            form={form}
            onSubmit={onSubmit}
            onClose={handleClose}
            isLoading={isLoading}
            id="forecaster-dialog"
        >
            <Grid item xs={12}>
                <ReactHookFormTextField
                    name="name"
                    label="Name"
                    control={control}
                    rules={{ required: { value: true, message: fieldIsRequiredMsg } }}
                    formErrors={errors}
                    isNumeric={false}
                    defaultValue=""
                    inputProps={undefined}
                    isMultiline={false}
                ></ReactHookFormTextField>
            </Grid>

            <Grid item xs={12}>
                <ReactHookFormAutoComplete
                    name="user"
                    label="User"
                    control={control}
                    formErrors={errors}
                    defaultValue={null}
                    options={users as any[]}
                    labelKeys={['name', 'id']}
                    getOptionLabel={(option: UserName) => (option ? `${option.name} (id: ${option.id})` : '')}
                    onChange={(event: any, newValue: any) => {
                        form.setValue('userId', newValue ? newValue.id : null);
                    }}
                />
            </Grid>
        </FormDialog>
    );
};

export default ForecasterDialog;
